var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg89(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 41",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reverse",
    transform: "translate(1.539064, 1.000000)",
    fillRule: "evenodd",
    strokeWidth: 1.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "base",
    stroke: "#687577",
    fill: "#FFFFFF",
    d: "M18.2839854,38.664675 C14.7462043,38.664675 10.4884174,38.5541918 6.91190401,38.4443991 L6.60342887,38.435077 C2.82322508,38.3194149 0.667357325,35.3501782 0.40107273,33.3821958 C0.388968884,33.2934639 -0.724930704,24.1375119 0.813295117,15.2335997 C2.27267303,6.78715706 9.65359787,0.326650435 13.0959315,0.0387035285 L13.0959315,0.0387035285 C17.7137213,-0.349023542 21.4195729,2.25699954 23.808872,4.24880495 C26.3333883,6.35489144 29.9133599,12.8633892 30.1488662,15.2201345 C30.3598189,17.3324357 30.3992428,31.7038865 30.1979732,33.3117627 C29.9496714,35.2973534 27.5582974,37.6316568 25.0797758,38.3073308 C24.1052433,38.5724906 21.4915044,38.664675 18.2839854,38.664675 Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.500000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hookstyle",
    transform: "scale(-1, 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "hook",
    fill: "none",
    transform: "translate(-8.000000, -10.000000)",
    d: "M3.58716581,4.86252597 C3.06706263,4.62380711 2.85229747,4.03585383 3.10747439,3.54929557 C3.36265132,3.06273731 3.99114002,2.86182379 4.5112432,3.10054265 C5.46056455,3.53626565 6.39450266,4.14450585 7.31484578,4.922185 C8.2443698,5.70762188 10.0438875,7.8539425 12.8028208,11.4459993 C13.1408693,11.8861293 13.0335172,12.4992928 12.5630432,12.8155382 C12.0925692,13.1317837 11.4371322,13.0313555 11.0990837,12.5912255 C8.44101017,9.13048544 6.68104531,7.03134029 5.90861111,6.37864246 C5.12699602,5.71818688 4.35258484,5.21384081 3.58716581,4.86252597 Z"
  }))), /*#__PURE__*/React.createElement("line", {
    id: "extracted",
    x1: 4.49787782,
    y1: 9.41435702,
    x2: 27.4609364,
    y2: 35.5,
    stroke: "none",
    strokeLinecap: "square"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg89);
export default __webpack_public_path__ + "static/media/8-9.aff396e8eea5ae5b51358df8c6d2f55c.svg";
export { ForwardRef as ReactComponent };